import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Separator} from '../../atoms/Separator/Separator';
import {Text} from '../../atoms/Text/Text';
import {RecentSearchesToolbarProps} from './RecentSearchesToolbarProps.interface';

export function RecentSearchesToolbar({
  autoSaveRecentKeyword,
  shouldShowRemoveAllRecentKeyword,
  onClickRemoveAllRecentKeyword,
  onClickSaveOrNotRecentKeyword,
  className,
  ...props
}: RecentSearchesToolbarProps) {
  return (
    <div className={twMerge('flex', className)} {...props}>
      <Text className="font-medium2-bold flex-1 text-theme-solid-100">
        {t('search_recent_keyword')}
      </Text>
      <div className="font-small2 flex items-center text-theme-solid-60">
        {shouldShowRemoveAllRecentKeyword && (
          <>
            <Text
              className="cursor-pointer"
              onClick={onClickRemoveAllRecentKeyword}
            >
              {t('search_delete_all')}
            </Text>
            <Separator className="mx-16pxr h-10pxr bg-theme-transparent-20" />
          </>
        )}
        <Text
          className="cursor-pointer"
          onClick={onClickSaveOrNotRecentKeyword}
          {...putTiaraObjectProps({
            click: {copy: autoSaveRecentKeyword ? 'off' : 'on'},
          })}
        >
          {autoSaveRecentKeyword
            ? t('search_before_off_save')
            : t('search_before_on_save')}
        </Text>
      </div>
    </div>
  );
}
